import { IRouter } from '@routers/interface';
import React from 'react';

export const routerPageError: IRouter = {
  path: '*',
  masterLayout: false,
  loader: React.lazy(()=>import('@view/PageError')),
};
